export const searchMdmActivitySiteCoreKeys = {
  contains: "FilterBy.Contains",
  activityHeader: "MDM.Activity.ActivityHeader",
  createNewActivityButton: "Activity.ActivityHeader.CreateNewActivityButton",
  searchActivityComponent: "MDM.Activity.SearchActivityComponent",
  activityName: "Activity.SearchActivityComponent.ActivityName",
  topicName: "Activity.SearchActivityComponent.TopicName",
  activityStatus: "Activity.SearchActivityComponent.ActivityStatus",
  programFramework: "Activity.SearchActivityComponent.ProgramFramework",
  projectFramework: "Activity.SearchActivityComponent.ProjectFramework",
  selectFrameworkType: "Activity.SearchActivityComponent.SelectFrameworkType",
  allRadioButton: "Activity.SearchActivityComponent.AllRadioButton",
  programRadioButton: "Activity.SearchActivityComponent.ProgramRadioButton",
  projectRadioButton: "Activity.SearchActivityComponent.ProjectRadioButton",
  filterByList: "Activity.SearchActivityComponent.FilterByList",
  statusList: "Activity.SearchActivityComponent.StatusList",
};

export const searchActivityResultSiteCoreKeys = {
  results: "MDM.Activity.Results",
  actionLabel: "Activity.Results.Action",
  activityLabel: "Activity.Results.Activity",
  allActivityLabel: "Activity.Results.AllActivity",
  modalityLabel: "Activity.Results.Modality",
  frameworkNameLabel: "Activity.Results.FrameworkName",
  topicLabel: "Activity.Results.Topic",
  unitsLabel: "Activity.Results.Units",
  unitsList: "Activity.Results.UnitsList",
  selectedProgramFramework: "Activity.Results.SelectedProgramFramework",
  selectedModality: "Activity.Results.SelectedModality",
  selectedTopics: "Activity.Results.SelectedTopics",
  modalityList: "Activity.Results.ModalityList",
  activityStatus: "Activity.Results.ActivityStatus",
  frameworkTypeLabel: "Activity.Results.FrameworkType",
  activityStatusList: "Activity.Results.ActivityStatusList",
};
